import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { TAnulacionSolicitudViewModel, SolicitudAnulacionViewModel } from './anulacion.types';

///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class AnulacionService {
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {}

    getSolicitudAnulacion(id: number): Observable<SolicitudAnulacionViewModel> {
        return this.http.get<SolicitudAnulacionViewModel>(this.baseUrl + 'api/importacion/anulacion/' + id).pipe();
    }

    createAnulacion(solicitudanulacion: SolicitudAnulacionViewModel): Observable<any> {
        return this.http.post<TAnulacionSolicitudViewModel>(this.baseUrl + 'api/importacion/anulacion', solicitudanulacion).pipe();
    }

    //antiguo, ya no se edita una anulación
    //editAnulacion(anulacion: TAnulacionSolicitudViewModel): Observable<any> {
    //    return this.http.put<TAnulacionSolicitudViewModel>(this.baseUrl + 'api/importacion/anulacion', anulacion).pipe();
    //}
}
